<template>
    <nav class="lnb-menu">
        <router-link to="/main" class="logo">
<!--            <img src="@/assets/resource/icon/logo.png" alt="로고" />-->
            <img src="@/assets/resource/icon/hover_logo.png" alt="Electroceuticals" class="login-logo-img" />
        </router-link>

        <ul class="lnb-menu__1deps-list">
            <!-- 1depth -->
            <li v-for="menu in menuData" :key="menu.menu_id"
                :class="{'lnb-menu__1deps-item': true, 'active': activeTitleMenu === menu.menu_id}">
                <h3 class="lnb-menu__1deps-tit" @click="toggleCollapse(menu.menu_id)">
                    <div class="lnb-menu__1deps-tit-left">
                        <span class="lnb-icon">
                            <component :is="getMenuIcon(menu.menu_name)"/>
                        </span>
                        <span>{{menu.menu_name}}</span>
                        <svg width="12" height="12" viewBox="0 0 24 24" :class="{ rotated: !collapsedMap['f'] }">
                            <path d="M8 10L12 14L16 10" stroke="#666" stroke-width="2" fill="none" />
                        </svg>
                    </div>
                </h3>
                <!-- 2depth -->
                <ul v-show="!collapsedMap[menu.menu_id]" class="lnb-menu__2deps-list">
                    <li v-for="child in menu.children" :key="child.menu_id"
                        :class="{'lnb-menu__2deps-item': true, 'active': activeMenu === child.menu_id } ">
                        <!-- 3depth O -->
                        <div v-if="child.childCount > 0" class="lnb-menu__2deps-tit" @click="toggleCollapse(child.menu_id); selectMenu(menu.menu_id, child.menu_id)">
                            {{child.menu_name}}
                            <svg width="10" height="10" viewBox="0 0 24 24" :class="{ rotated: !collapsedMap[child.menu_id] }">
                                <path d="M8 10L12 14L16 10" stroke="#666" stroke-width="2" fill="none" />
                            </svg>
                        </div>
                        <!-- 3depth X -->
                        <router-link v-else :to="child.menu_url || '/main'" class="lnb-menu__2deps-tit" @click.native="selectMenu(menu.menu_id, child_menu_id)" >
                            {{child.menu_name}}
                        </router-link>

                        <!-- 3depth -->
                        <ul v-if="child.childCount > 0" class="lnb-menu__3deps-list">
                            <li v-for="grandChild in child.children" :key="grandChild.menu_id"
                                :class="{ active: activeMenu === grandChild.menu_id }">
                                <router-link :to="grandChild.menu_url" class="lnb-menu__3deps-tit"
                                             @click.native="selectMenu(child.menu_id, grandChild.menu_id)">
                                    {{grandChild.menu_name}}
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </nav>
</template>

<script setup>
import api, {urls} from '@/api'
import { convertUtils } from '@/utils/convertUtils'
import { useRouter, useRoute  } from 'vue-router'
import { reactive, ref, onMounted, watch, h } from 'vue'


const router = useRouter()
const route = useRoute()

const collapsedMap = reactive({})
const activeTitleMenu =  ref('')
const activeMenu =  ref('')
const menuData = ref([])
const orgData = ref([])

// 메뉴별 아이콘
const getMenuIcon = (menuName) => {
    const iconMap = {
        '진단관리': () => h('svg', {
            width: "20",
            height: "20",
            fill: "none",
            viewBox: "0 0 24 24"
        }, [
            h('circle', { cx: "12", cy: "12", r: "8", fill: "#1c84ad" }),
            h('path', {
                d: "M12 8v6M12 14l2 2M12 14l-2 2",
                stroke: "#fff",
                'stroke-width': "1.2",
                'stroke-linecap': "round"
            })
        ]),

        '처방 관리': () => h('svg', {
            width: "20",
            height: "20",
            fill: "none",
            viewBox: "0 0 24 24"
        }, [
            h('rect', { x: "4", y: "7", width: "16", height: "10", rx: "3", fill: "#40bfa3" }),
            h('rect', { x: "9", y: "11", width: "6", height: "6", rx: "3", fill: "#fff" }),
            h('rect', { x: "8", y: "4", width: "8", height: "4", rx: "2", fill: "#fcba37" })
        ]),

        '환자 관리': () => h('svg', {
            width: "20",
            height: "20",
            fill: "none",
            viewBox: "0 0 24 24"
        }, [
            h('circle', { cx: "12", cy: "9", r: "4", fill: "#1593c0" }),
            h('ellipse', { cx: "12", cy: "16", rx: "7", ry: "4", fill: "#9dbfe3" })
        ]),

        '콘텐츠 관리': () => h('svg', {
            width: "20",
            height: "20",
            fill: "none",
            viewBox: "0 0 24 24"
        }, [
            h('rect', { x: "4", y: "4", width: "16", height: "16", rx: "3", fill: "#1593c0" }),
            h('rect', { x: "6", y: "7", width: "12", height: "2", rx: "1", fill: "#fff" }),
            h('rect', { x: "6", y: "10", width: "12", height: "2", rx: "1", fill: "#fff" }),
            h('rect', { x: "6", y: "13", width: "8", height: "2", rx: "1", fill: "#fff" }),
            h('circle', { cx: "18", cy: "18", r: "3", fill: "#fcba37" }),
            h('path', {
                d: "M17 18h2M18 17v2",
                stroke: "#fff",
                'stroke-width': "1",
                'stroke-linecap': "round"
            })
        ]),

        '통계 리포트': () => h('svg', {
            width: "20",
            height: "20",
            fill: "none",
            viewBox: "0 0 24 24"
        }, [
            h('rect', { x: "3", y: "3", width: "18", height: "18", rx: "3", fill: "#40bfa3" }),
            h('rect', { x: "6", y: "14", width: "2", height: "6", rx: "1", fill: "#fff" }),
            h('rect', { x: "9", y: "11", width: "2", height: "9", rx: "1", fill: "#fff" }),
            h('rect', { x: "12", y: "8", width: "2", height: "12", rx: "1", fill: "#fff" }),
            h('rect', { x: "15", y: "12", width: "2", height: "8", rx: "1", fill: "#fff" }),
            h('path', {
                d: "M16 8l2-2 2 2",
                stroke: "#1593c0",
                'stroke-width': "1.5",
                fill: "none",
                'stroke-linecap': "round",
                'stroke-linejoin': "round"
            })
        ]),

        '계정 관리': () => h('svg', {
            width: "20",
            height: "20",
            fill: "none",
            viewBox: "0 0 24 24"
        }, [
            h('circle', { cx: "12", cy: "9", r: "4", fill: "#1593c0" }),
            h('ellipse', { cx: "12", cy: "17", rx: "8", ry: "3", fill: "#9dbfe3" }),
            h('circle', { cx: "18", cy: "6", r: "3", fill: "#fcba37" }),
            h('path', {
                d: "M17.5 6h1M18 5.5v1",
                stroke: "#fff",
                'stroke-width': "0.8",
                'stroke-linecap': "round"
            })
        ]),

        '시스템 설정': () => h('svg', {
            width: "20",
            height: "20",
            fill: "none",
            viewBox: "0 0 24 24"
        }, [
            h('circle', { cx: "12", cy: "12", r: "8", fill: "#9dbfe3" }),
            h('circle', { cx: "12", cy: "12", r: "3", fill: "#fff" }),
            h('rect', { x: "11", y: "4", width: "2", height: "4", rx: "1", fill: "#1593c0" }),
            h('rect', { x: "11", y: "16", width: "2", height: "4", rx: "1", fill: "#1593c0" }),
            h('rect', { x: "4", y: "11", width: "4", height: "2", rx: "1", fill: "#1593c0" }),
            h('rect', { x: "16", y: "11", width: "4", height: "2", rx: "1", fill: "#1593c0" })
        ])
    }

    return iconMap[menuName] || (() => h('div'))
}

const toggleCollapse = (menuName) => {
    collapsedMap[menuName] = !collapsedMap[menuName];
}

// 초기 collapsedMap 설정 및 현재 경로 활성화
const initializeMenuState = () => {
    const currentPath = router.currentRoute.value.path
    let foundActiveMenu = null

    // 대시보드인 경우
    if (currentPath === '/main') {
        selectMenu('Dashboard', 'Dashboard')
    }

    // 한 번의 순회로 collapsedMap 초기화 + 활성 메뉴 찾기
    menuData.value.forEach(menu => {
        // 1depth 메뉴 기본 접힘 상태
        collapsedMap[menu.menu_id] = true

        if (menu.children && menu.children.length > 0) {
            menu.children.forEach(subMenu => {
                // 2depth 메뉴 기본 접힘 상태 (3depth가 있는 경우만)
                if (subMenu.childCount > 0) {
                    collapsedMap[subMenu.menu_id] = true
                }

                // 3depth 메뉴 확인
                if (subMenu.children && subMenu.children.length > 0) {
                    subMenu.children.forEach(thirdMenu => {
                        if (thirdMenu.menu_url === currentPath) {
                            foundActiveMenu = {
                                parentMenu: menu,
                                subMenu: subMenu,
                                currentMenu: thirdMenu,
                                depth: 3
                            }
                        }
                    })
                }

                // 2depth 메뉴에서 직접 매치
                if (subMenu.menu_url === currentPath) {
                    foundActiveMenu = {
                        parentMenu: menu,
                        currentMenu: subMenu,
                        depth: 2
                    }
                }
            })
        }
    })

    // 활성 메뉴가 있으면 해당 메뉴 펼치기 및 활성화
    if (foundActiveMenu) {
        // 부모 메뉴들 펼치기
        collapsedMap[foundActiveMenu.parentMenu.menu_id] = false

        if (foundActiveMenu.depth === 3 && foundActiveMenu.subMenu) {
            collapsedMap[foundActiveMenu.subMenu.menu_id] = false
            selectMenu(foundActiveMenu.subMenu.menu_id, foundActiveMenu.currentMenu.menu_id)
        } else {
            selectMenu(foundActiveMenu.parentMenu.menu_id, foundActiveMenu.currentMenu.menu_id)
        }
    }
}

const selectMenu = (title, name) => {
    activeTitleMenu.value = title;
    activeMenu.value = name;
}

const getList = () => {
    api.get(urls.menu.list, {params: {useYn: 'Y'}
    }).then(res => {
        const list = res.data
        orgData.value = list
        menuData.value = convertUtils.buildMenuTree(list)

        initializeMenuState()
    }).catch(error => {
        // 403 등의 오류 발생 시 로그만 기록하고 UI에 영향을 주지 않음
        // if (error.response?.status === 403) {
        //     console.log('Access denied - no valid token')
        // } else {
        //     console.error('Failed to fetch menu:', error)
        // }
    })
}
onMounted(() => {
    getList()
})

watch(() => route.path, () => { initializeMenuState() })
</script>